module.exports = __webpack_public_path__ + "static/media/black.1a1957e1.jpg";